import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MwcModalRef, MwcModalService } from 'mwc/modal';
import { Subject } from 'rxjs';
import { NewTemplateSelectorComponent } from 'src/app/_shared/modules/shared-ui/components/new-template-selector/new-template-selector.component';
import { GEOData, topicIdea } from '../../../models/topic';
import { CampaignData } from '../../../../campaigns/view-campaigns/view-campaigns.component';
@Injectable({
    providedIn: 'root'
})
export class NewTemplateHelperService {

    private modalService;
    private templateTile;
    private modalRef;

  openTemplateSelector(data: topicIdea = null, textTitle: string = null, campaignData: CampaignData = null, geoData:GEOData=null) {
    this.createTemplate(data, textTitle, campaignData, geoData);
    }

  init(modalService: MwcModalService, templateTitle) {
    this.modalService = modalService;
    this.templateTile = templateTitle;
  }

  closeTemplateSelector() {
    if (this.modalRef)
      this.modalRef.close();
  }

  createTemplate(data: topicIdea = null, textTitle: string = null, campaignData: CampaignData = null, geoData: GEOData =null) {
    this.modalRef = this.modalService.create({
          mwcData: {
            topicIdeaData: data,
            textTitle: textTitle,
            campaignData: campaignData,
            GEOData: geoData
          },
          mwcBodyStyle:{'padding':'0'},
          mwcTitle: this.templateTile,
          mwcWidth: '1200px',
          mwcCentered: true,
          mwcComponentParams: {
            containerHeight: 'calc(100vh - 210px)'
          },
          mwcContent: NewTemplateSelectorComponent,
          mwcClassName: 'new-template-service-modal',
          mwcFooter:null,
          mwcMaskClosable:false
        });
      }
}
